import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api
      .get("/products")
      .then((r) => setProducts(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  const nonInstruments = useMemo(
    () => products.filter((p) => p.category !== "Instruments"),
    [products]
  );

  const categories = useMemo(() => {
    const set = new Set(nonInstruments.map((p) => p.category));
    return ["All", ...Array.from(set)];
  }, [nonInstruments]);

  const visible = useMemo(
    () => (filter === "All" ? nonInstruments : nonInstruments.filter((p) => p.category === filter)),
    [nonInstruments, filter]
  );

  // Bento span pattern
  const spans = ["lg", "sm", "sm", "lg", "md", "md", "xl"];

  return (
    <div data-testid="shop-page" className="bg-stone-950 text-stone-50 pt-14 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16">
        <div className="border-b border-stone-800/60 pb-12 mb-12">
          <p className="text-overline text-amber-600 mb-4">The Shop</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter uppercase">
            Pieces ready to leave the bench.
          </h1>
          <p className="text-stone-400 mt-6 max-w-2xl text-lg leading-relaxed">
            Each piece is one of one. When it sells, it's gone. Apple Pay and
            cards accepted at checkout.
          </p>
        </div>

        <div data-testid="shop-filters" className="flex flex-wrap gap-3 mb-12">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c}`}
              onClick={() => setFilter(c)}
              className={`text-overline px-5 py-3 border transition-colors ${
                filter === c
                  ? "border-amber-600 bg-amber-700 text-stone-50"
                  : "border-stone-800 hover:border-stone-600 text-stone-300"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <p data-testid="shop-loading" className="text-stone-500">
            Loading work…
          </p>
        ) : visible.length === 0 ? (
          <p data-testid="shop-empty" className="text-stone-500">
            Nothing here yet — check back soon.
          </p>
        ) : (
          <div
            data-testid="shop-grid"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {visible.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
